<div class="module-box-wrapper overflow-y-auto">
  <div class="module-box-wrapper-inner h-100">
    <router-outlet></router-outlet>
  </div>
</div>
